import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paginacao',
  templateUrl: './paginacao.component.html',
  styleUrls: ['./paginacao.component.scss']
})
export class PaginacaoComponent {
  @Input() totalPaginas: number;
  @Input() paginaAtual: number;
  @Output() mudouPagina = new EventEmitter<number>();

  showDropdownEsquerdo = false;
  showDropdownDireito = false;

  alterarPagina(pagina: number) {
    if (pagina >= 1 && pagina <= this.totalPaginas && pagina !== this.paginaAtual) {
      this.paginaAtual = pagina;
      this.mudouPagina.emit(this.paginaAtual);
    }
    this.fecharDropdowns(); // <- fecha sempre, mesmo que a página não mude
  }

  anterior() {
    this.alterarPagina(this.paginaAtual - 1);
    this.fecharDropdowns(); // <- fecha sempre, mesmo que a página não mude
  }

  proximo() {
    this.alterarPagina(this.paginaAtual + 1);
    this.fecharDropdowns(); // <- fecha sempre, mesmo que a página não mude
  }

  get paginasPrincipais(): (number | 'ellipsis-left' | 'ellipsis-right')[] {
    const total = this.totalPaginas;
    const atual = this.paginaAtual;
    const paginas: (number | 'ellipsis-left' | 'ellipsis-right')[] = [];

    if (total <= 7) {
      for (let i = 1; i <= total; i++) {
        paginas.push(i);
      }
    } else {
      paginas.push(1);

      if (atual <= 4) {
        // Mostra até 4 e reticências à direita
        for (let i = 2; i <= 5; i++) {
          paginas.push(i);
        }
        paginas.push('ellipsis-right');
      } else if (atual >= total - 3) {
        // Reticências à esquerda, mostra últimas
        paginas.push('ellipsis-left');
        for (let i = total - 4; i < total; i++) {
          paginas.push(i);
        }
      } else {
        // Reticências nos dois lados
        paginas.push('ellipsis-left');
        for (let i = atual - 1; i <= atual + 1; i++) {
          paginas.push(i);
        }
        paginas.push('ellipsis-right');
      }

      paginas.push(total);
    }

    return paginas;
  }

  paginasIntermediarias(): number[] {
    const todas = [];
    for (let i = 2; i < this.totalPaginas; i++) {
      if (!this.paginasPrincipais.includes(i)) {
        todas.push(i);
      }
    }
    return todas;
  }

  paginasEsquerda(): number[] {
    const inicio = 2;
    const fim = Math.min(this.paginaAtual - 2, this.totalPaginas - 1);
    const paginas = [];
    for (let i = inicio; i <= fim; i++) {
      if (!this.paginasPrincipais.includes(i)) {
        paginas.push(i);
      }
    }
    return paginas;
  }

  paginasDireita(): number[] {
    const inicio = Math.max(this.paginaAtual + 2, 2);
    const fim = this.totalPaginas - 1;
    const paginas = [];
    for (let i = inicio; i <= fim; i++) {
      if (!this.paginasPrincipais.includes(i)) {
        paginas.push(i);
      }
    }
    return paginas;
  }

  toggleDropdownEsquerdo() {
    this.showDropdownEsquerdo = !this.showDropdownEsquerdo;
    this.showDropdownDireito = false; // fecha o outro
  }

  toggleDropdownDireito() {
    this.showDropdownDireito = !this.showDropdownDireito;
    this.showDropdownEsquerdo = false; // fecha o outro
  }

  fecharDropdowns() {
    this.showDropdownEsquerdo = false;
    this.showDropdownDireito = false;
  }

}
